const fields = {
  ID: 'id',
  NAME: 'name'
};

export default {
  fields
};
